import React from "react";
import { FiX } from "react-icons/fi";
import { useApp } from "../context/AppContext";

export default function Notifications() {
  const { notifications, dismissNotification } = useApp();

  if (notifications.length === 0) return null;

  return (
    <div className="notification-container">
      {notifications.map((n) => (
        <div key={n.id} className={`notification-toast ${n.type}`}>
          <span>{n.message}</span>
          <button className="close-btn" onClick={() => dismissNotification(n.id)}>
            <FiX />
          </button>
        </div>
      ))}
    </div>
  );
}
